import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { dsI18n, getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { Icon, ArrowDownSVGpath } from '@skatteetaten/ds-icons';
import './styles.css';


const getTopBannerSkipLinkTargetDefault = ()=>'main';

var styles = {
    "skipLink": "TopBannerSkipLink-module_skipLink__NnusL",
    "skipLinkContent": "TopBannerSkipLink-module_skipLinkContent__JhlAE",
    "icon": "TopBannerSkipLink-module_icon__GIbj4"
};

const TopBannerSkipLink = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, shadowRootNode, target = getTopBannerSkipLinkTargetDefault(), children }, ref)=>{
    const { t } = useTranslation('ds_layout', {
        i18n: dsI18n
    });
    const handleClick = (event)=>{
        event.preventDefault();
        const container = shadowRootNode ? shadowRootNode.querySelector(target) : document.querySelector(target);
        if (container) {
            container.tabIndex = -1;
            container.focus();
        }
    };
    return /*#__PURE__*/ jsx("a", {
        ref: ref,
        id: id,
        href: target,
        className: `${styles.skipLink} ${className}`.trim(),
        lang: lang,
        "data-testid": dataTestId,
        "data-skip-link": 'ds-skip-link',
        onClick: handleClick,
        children: /*#__PURE__*/ jsxs("span", {
            className: styles.skipLinkContent,
            children: [
                /*#__PURE__*/ jsx(Icon, {
                    className: styles.icon,
                    svgPath: ArrowDownSVGpath
                }),
                children ?? t('topbanner.SkipLinkText')
            ]
        })
    });
});
TopBannerSkipLink.displayName = 'TopBannerSkipLink';

export { TopBannerSkipLink };
